<script type="text/ecmascript-6">
import GeneralMixin from "JS/mixins/campaign/general";
import StringFilters from "JS/filters/stringFilters";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AdvocateBadge",
  filters: StringFilters,
  mixins: [GeneralMixin],
  props: {
    advocateInfo: {
      required: true,
      type: Object
    },
    welcomeBackLabel: {
      required: true,
      type: String
    },
    wrongInfoLabel: {
      type: String,
      default: ""
    },
    returnAdvocateMessage: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters({
      cookieBadgeVisible: "forms/cookieBadgeVisible",
      descriptionVisible: "navigation/campaignDescriptionVisible"
    }),
    allActionsAlreadyTaken() {
      return this.$store.getters["navigation/allActionsAlreadyTaken"];
    },
    name() {
      const { anonymousName } = this.advocateInfo;
      return anonymousName || "";
    },
    hasAdvocateBadge() {
      return this.advocateInfo.id !== undefined;
    },
    legislatorsPulled() {
      return this.$store.getters["legislators/legislatorsPulled"];
    },
    location() {
      const { zip5, state } = this.advocateInfo;
      let { city } = this.advocateInfo;

      if (city && state) {
        city = `${city},`;
      }

      return [city, state, zip5].filter(Boolean).join(" ");
    },
    showCookieBadge() {
      return (
        !this.legislatorsPulled &&
        this.hasAdvocateBadge &&
        !this.completedAllActions &&
        this.currentStep !== null &&
        !this.currentStep.includes("custom")
      );
    },
    showCookieBadgeConvo() {
      return this.showCookieBadge && !this.descriptionVisible;
    }
  },
  watch: {
    showCookieBadge(bool) {
      this.setCookieBadge(bool);
    },
    showCookieBadgeConvo(bool) {
      this.setCookieBadgeConvo(bool);
    }
  },
  mounted() {
    this.setCookieBadge(this.showCookieBadge);
  },
  methods: {
    ...mapActions({
      setCookieBadge: "forms/cookieBadgeVisible",
      setCookieBadgeConvo: "forms/cookieBadgeConvoVisible"
    })
  }
};
</script>
